module.exports = __webpack_public_path__ + "img/vip-banner.0f4d5979.png";